(function () {
   'use strict';

   var MOBILE_QUERY = '(max-width: 600px)';

   function init() {
      var heads = document.querySelectorAll('.footer__acc:not(.footer__acc--static) > .footer__acc-head');
      if (!heads.length) return;

      var mq = window.matchMedia(MOBILE_QUERY);

      function isMobile() {
         return mq.matches;
      }

      heads.forEach(function (head) {
         head.addEventListener('click', function () {
            if (!isMobile()) return;
            var acc = head.closest('.footer__acc');
            if (!acc) return;
            var open = acc.classList.toggle('is-open');
            head.setAttribute('aria-expanded', open ? 'true' : 'false');
         });
      });

      // Ao voltar para desktop, garante que nada fique no estado "fechado"
      function sync() {
         if (mq.matches) return;
         document.querySelectorAll('.footer__acc.is-open').forEach(function (acc) {
            acc.classList.remove('is-open');
            var head = acc.querySelector('.footer__acc-head');
            if (head) head.setAttribute('aria-expanded', 'false');
         });
      }

      if (mq.addEventListener) {
         mq.addEventListener('change', sync);
      } else if (mq.addListener) {
         mq.addListener(sync);
      }
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }
})();
